module.exports = __webpack_public_path__ + "static/media/54c49cd4.jpg";